import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

export const getBrands = createAsyncThunk(
    "Brand/get",
    async (payload, { rejectWithValue, dispatch }) => {
        try {
            dispatch(setActivePayload(payload));
            const filteredPayload = Object.fromEntries(
                Object.entries(payload).filter(
                    ([, value]) => value !== null && value !== undefined && value !== ""
                )
            );
            const params = new URLSearchParams();

            for (const [key, value] of Object.entries(filteredPayload)) {
                if (Array.isArray(value)) {
                    // If the value is an array, append each item with the same key
                    value.forEach((item) => {
                        params.append(key, item);
                    });
                } else {
                    // For non-array values, just append normally
                    params.append(key, value);
                }
            }
            const queryString = params.toString();

            const { data } = await axios.get(`${API_URL.BRAND.SLUG}?${queryString}`);
            return data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

// Lookup variant — hits the permission-free /lookup endpoint. Used by dropdowns
// on screens of other modules; the management list keeps using getBrands.
export const getBrandsLookup = createAsyncThunk(
    "Brand/getLookup",
    async (payload, { rejectWithValue }) => {
        try {
            const filteredPayload = Object.fromEntries(
                Object.entries(payload).filter(
                    ([, value]) => value !== null && value !== undefined && value !== ""
                )
            );
            const params = new URLSearchParams();

            for (const [key, value] of Object.entries(filteredPayload)) {
                if (Array.isArray(value)) {
                    value.forEach((item) => {
                        params.append(key, item);
                    });
                } else {
                    params.append(key, value);
                }
            }
            const queryString = params.toString();

            const { data } = await axios.get(`${API_URL.BRAND.LOOKUP}?${queryString}`);
            return data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const createBrand = createAsyncThunk(
    "Brand/create",
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await axios.post(`${API_URL.BRAND.SLUG}`, payload);
            return data.data;
        } catch (error) {
            return rejectWithValue(error.data);
        }
    }
);

export const editBrand = createAsyncThunk(
    "User/put",
    async (payload, { rejectWithValue }) => {
      try {
        const { data } = await axios.put(`${API_URL.BRAND.SLUG}`, payload);
        return data.data;
      } catch (error) {
        return rejectWithValue(error.data);
      }
    }
  );

  export const deleteBrand = createAsyncThunk(
    "Brand/delete",
    async (payload, { rejectWithValue }) => {
      try {
        const { data } = await axios.delete(`${API_URL.BRAND.SLUG}/${payload}`);
        return data.data;
      } catch (error) {
        return rejectWithValue(error.data);
      }
    }
  );

const brandSlice = createSlice({
    name: "brand",
    initialState: {
        brand_list: [],
        current_values: null,
        active_payload: null,
    },
    reducers: {
        setCurrentValues(state, action) {
            state.current_values = action.payload;
        },
        setActivePayload(state, action) {
            state.active_payload = action.payload;
        },
        resetCurrentValue(state) {
            state.current_values = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getBrands.fulfilled, (state, action) => {
            state.brand_list = action.payload.data.list;
        });
        builder.addCase(getBrandsLookup.fulfilled, (state, action) => {
            state.brand_list = action.payload.data.list;
        });
    }
})

export const { setCurrentValues, setActivePayload, resetCurrentValue } = brandSlice.actions;
export default brandSlice.reducer;
